import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { selectIsProcessingUserStatusUpdate } from '../../../../../../store/selectors/userListSelector';
import { deactivateUser, reactivateUser } from '../../../../usersListReducer';

import UserAccountActivationToggleCard from './UserAccountActivationToggleCard';
import {
  USER_ACCOUNT_ACTIVATION_TOGGLE_CONTENT,
  USER_ACCOUNT_ACTIVATION_TOGGLE_MODES,
} from './userAccountActivationToggleConfig';
import UserAccountActivationToggleConfirmationModal from './UserAccountActivationToggleConfirmationModal';

const UserAccountActivationToggle = ({
  mode = USER_ACCOUNT_ACTIVATION_TOGGLE_MODES.ACTIVATE,
  userId,
}) => {
  const dispatch = useDispatch();
  const isProcessingUserStatusUpdate = useSelector(selectIsProcessingUserStatusUpdate);
  const content =
    USER_ACCOUNT_ACTIVATION_TOGGLE_CONTENT[mode] ||
    USER_ACCOUNT_ACTIVATION_TOGGLE_CONTENT[USER_ACCOUNT_ACTIVATION_TOGGLE_MODES.ACTIVATE];
  const isActivateMode = mode === USER_ACCOUNT_ACTIVATION_TOGGLE_MODES.ACTIVATE;
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  const handleOpen = useCallback(() => {
    setIsDialogOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setIsDialogOpen(false);
    setIsChecked(false);
  }, []);

  const handleCheckChange = useCallback((event) => {
    setIsChecked(event.target.checked);
  }, []);

  const handleConfirm = useCallback(() => {
    if (isActivateMode) {
      dispatch(reactivateUser({ id: userId }));
    } else {
      dispatch(deactivateUser({ id: userId }));
    }
    handleClose();
  }, [dispatch, handleClose, isActivateMode, userId]);

  return (
    <>
      <UserAccountActivationToggleCard
        content={content}
        onActionClick={handleOpen}
        isLoading={isProcessingUserStatusUpdate}
      />
      <UserAccountActivationToggleConfirmationModal
        content={content}
        isDialogOpen={isDialogOpen}
        isChecked={isChecked}
        onClose={handleClose}
        onConfirm={handleConfirm}
        onCheckChange={handleCheckChange}
      />
    </>
  );
};

UserAccountActivationToggle.propTypes = {
  mode: PropTypes.oneOf(Object.values(USER_ACCOUNT_ACTIVATION_TOGGLE_MODES)),
  userId: PropTypes.string,
};

export default UserAccountActivationToggle;
